import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";

import App from "./App.vue";
import store from "./store";
import { routes } from "./router";
import VueProgressBar from "vue-progressbar";
import VueAnalytics from "vue-analytics";

import "./assets/styles/index.css";

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes,
});

const options = {
  color: "rgb(143, 255, 199)",
  failedColor: "red",
  height: "2px",
};

Vue.use(VueProgressBar, options);

Vue.use(VueAnalytics, {
  id: "UA-168791225-1",
});

new Vue({
  render: (h) => h(App),
  store,
  router,
  mounted() {
    // Added functionality
    // this.$store.commit("setUnanswered", questions);
    // this.$store.dispatch("init");
  },
}).$mount("#app");
